module.exports = __webpack_public_path__ + "img/goods1_2.0f5064ce.jpg";